import { apiClientStore } from '@yoop/whitelabel-api-client';
import type { WhitelabelApiClient } from '@yoop/whitelabel-api-client';

/**
 * The store holds the client as optional because it starts out unset. `main.ts` calls
 * `initializeClient` at bootstrap, before any comms message can be handled, so every reader below
 * runs with it present. Failing loudly keeps that invariant visible instead of spreading optional
 * chaining that would silently skip authenticated calls. Mirrors the existing guard in
 * `whitelabel-my-yoop`'s `onAssignTokenToCurrentUser`.
 */
export const requireApiClient = (): WhitelabelApiClient => {
  const { apiClient } = apiClientStore.getState();
  if (!apiClient) {
    throw new Error('Whitelabel API client was used before initializeClient() ran.');
  }
  return apiClient;
};
